import script from "./EventSessionInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSessionInvitation.vue?vue&type=script&setup=true&lang=js"

import "./EventSessionInvitation.vue?vue&type=style&index=0&id=d89130b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d89130b8"]])

export default __exports__